import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;

`;

export const Buttons = styled.div`
  display: flex;
  position: relative;
  .btn {
    margin-right: 20px;
  }
  margin: 0 0 30px;
  & > div {
    position: relative;
    margin-right: 10px;
  }
`;

export const Reloader = styled.div`
  position: relative;
`;

export const Title = styled.div`
  margin: 0 0 1.3rem;
  font-size: 1.2rem;
  color: #fff;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  min-height: 580px;
  position: relative;
`;

export const Offline = styled.div`
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: rgba(12, 18, 16, 0.82);
  backdrop-filter: blur(2px);
  border-radius: 0 0 14px 14px;
  user-select: none;

  .dot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #161e23;
    border: 1px solid #3d4952;
    box-shadow: 0 0 0 6px rgba(122, 131, 138, 0.06);
  }
  .dot::before {
    content: '';
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #7a838a;
  }
  .label {
    color: #aab2b8;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  }
`;

export const Left = styled.div`
  width: 500px;
  /* margin-right: 20px; */
  img {
    pointer-events: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    user-drag: none;
    -webkit-touch-callout: none;
  }
`;

export const Right = styled.div`
  width: 50%;
  color: #e6eaec;
  position: relative;
  /* внутренние компоненты выровнены по левому краю */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding-left: 8px;
  &.loading1::after,
  &.loading::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(14, 21, 24, 0.72);
    backdrop-filter: blur(1px);
    z-index: 3;
  }
  &.loading1::after {
    background: rgba(14, 21, 24, 0.72);
  }
  &.loading1::before {
    content: '';
    z-index: 11;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: url(/images/loader.svg) no-repeat 50%;
    //background-size: 70px auto;
  }
`;

export const Items = styled.div`
  margin: 0 0 30px;
`;

export const ButtonPlace = styled.div`
  position: relative;
  margin: 1rem 0 0;
`;
